export default __webpack_public_path__ + "static/media/ice_bear@3x.b60c9efd.png";